import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import EmployeeComponent from '../components/EmployeeComponent'

const mapStateToProps = (state) => {
  return {
    employee: state.employee,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeComponent)
